export const getNewsList = state => {
    return state.list
}

export const getNewsDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/news/getters.js